import PropTypes from 'prop-types';
import React from 'react';

import Button from '../../../components/Button';
import eslLogo from './ESL_Icon_RGB_NEG.png';
import styles from './connections.scss';

const providerIcons = {
  facebook: 'facebook-f',
  google: 'google',
  twitter: 'twitter',
  twitch: 'twitch',
  steam: 'steam-symbol',
  discord: 'discord',
};

const propTypes = {
  connections: PropTypes.arrayOf(PropTypes.shape({
    provider: PropTypes.string.isRequired,
    nickname: PropTypes.string,
    name: PropTypes.string,
  })),
  availableConnections: PropTypes.arrayOf(PropTypes.string).isRequired,
  onDisconnect: PropTypes.func.isRequired,
  onConnect: PropTypes.func.isRequired,
};

const Connections = ({
  connections,
  onDisconnect,
  availableConnections,
  onConnect,
}) => (
  <>
    <table className={styles.connections}>
      <tbody>
        { connections && connections?.length > 0 && connections.map((connection) => (
          <tr key={connection.id}>
            <td className={styles.providerIcon}>
              {connection.provider !== 'esl' && (
              <i
                className={`fab fa-${providerIcons[connection.provider]}`}
              />
              )}
              {connection.provider === 'esl' && (
                <img src={eslLogo} alt="esl log" />
              )}
            </td>
            <td className={styles.name}>
              <div>{connection.nickname || connection.name}</div>
              <div className={styles.email}>
                { connection.email && <div>{connection.email}</div> }
              </div>
            </td>
            <td className={styles.action}>
              {connection.provider !== 'esl' && (
                <Button
                  onClick={onDisconnect(connection)}
                  outline
                  muted
                >
                  Disconnect
                </Button>
              )}
            </td>
          </tr>
        ))}
        { availableConnections && availableConnections.map((provider) => (
          <tr key={provider}>
            <td className={styles.providerIcon}>
              {provider !== 'esl' && (
              <i
                className={`fab fa-${providerIcons[provider]}`}
              />
              )}
              {provider === 'esl' && (
                <img src={eslLogo} alt="esl log" />
              )}
            </td>
            <td className={styles.providerName}>
              {provider === 'esl' ? 'ESL' : provider}
            </td>
            <td className={styles.action}>
              <Button
                onClick={onConnect(provider)}
                outline
              >
                Connect
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </>
);

Connections.propTypes = propTypes;

export default Connections;
